import { render, staticRenderFns } from "./ProductDownloads.vue?vue&type=template&id=75ce5bee&"
import script from "./ProductDownloads.ts?vue&type=script&lang=ts&"
export * from "./ProductDownloads.ts?vue&type=script&lang=ts&"
import style0 from "./ProductDownloads.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSelect} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect})
